<template>
  <v-container>
    <div class="align-center pt-2">
      <span
        class="pl-2"
        style="font-size: 20px; font-weight: bold; color: #00a99d"
        >ผลการตรวจปัสสาวะ (URINE ANALYSIS)</span
      >
    </div>
    <v-row class="pl-3 mt-2"
      ><span class="ml-2 mt-5 pt-3" style="font-size: 16px; color: #333333"
        >สี (Colors)</span
      ><v-col cols="6" class="mt-1 ml-0"
        ><v-text-field
          v-model="item_urinalysis[0].UrineResults.urinalysis.colors"
          flat
          solo
          dense
          hide-details
          placeholder="ระบุสี"
          class="ma-2 textfield-sty"
          color="#00A99D"
        ></v-text-field></v-col
    ></v-row>
    <v-row class="pl-3 mt-0"
      ><span class="ml-2 mt-5 pt-3" style="font-size: 16px; color: #333333"
        >ความขุ่นใส (Appearance)</span
      ><v-col cols="6" class="mt-1 ml-0"
        ><v-text-field
          v-model="item_urinalysis[0].UrineResults.urinalysis.appearance"
          flat
          solo
          dense
          hide-details
          placeholder="ระบุความขุ่นใส"
          class="ma-2 textfield-sty"
          color="#00A99D"
        ></v-text-field></v-col
    ></v-row>
    <v-data-table
      class="elevation-1 my-table mt-4 ml-1"
      style="background-color: #f6f6f6"
      :headers="headers"
      :items="item_urinalysis"
      :hide-default-footer="true"
    >
      <template v-slot:body.prepend="props">
        <!-- Urine Strip -->
        <tr style="background-color: #f2fcf5">
          <td>
            <span style="color: #00a99d">Urine Strip</span>
          </td>
          <td></td>
          <td></td>
        </tr>
        <!-- ---- 1.1 ---- -->
        <tr>
          <td>
            <span>ความถ่วงจำเพาะ (Sp Gr)</span>
          </td>
          <td>
            <v-text-field
              v-model="
                props.items[0].UrineResults.urineStrip.specificGravity.result
              "
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลตรวจ"
              class="ma-2 textfield-sty"
              color="#00A99D"
              @keypress="validateNumber"
              type="number"
            ></v-text-field>
          </td>
          <td style="text-align: center">1.003 - 1.035</td>
        </tr>
        <td class="table-border"></td>
        <!-- ---- 1.2 ---- -->
        <tr>
          <td>
            <span>ค่าความเป็นกรด,ด่าง (pH)</span>
          </td>
          <td>
            <v-text-field
              v-model="props.items[0].UrineResults.urineStrip.ph.result"
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลตรวจ"
              class="ma-2 textfield-sty"
              color="#00A99D"
              @keypress="validateNumber"
              type="number"
            ></v-text-field>
          </td>
          <td style="text-align: center">5.0-8.0</td>
        </tr>
        <!-- ---- 1.3 ---- -->
        <tr>
          <td>
            <span>น้ำตาลในปัสสาวะ (Glucose)</span>
          </td>
          <td>
            <v-text-field
              v-model="props.items[0].UrineResults.urineStrip.glucose.result"
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลตรวจ"
              class="ma-2 textfield-sty"
              color="#00A99D"
            ></v-text-field>
          </td>
          <td style="text-align: center">Negative</td>
        </tr>
        <!-- ---- 1.4 ---- -->
        <tr>
          <td>
            <span>โปรตีนในปัสสาวะ (Protein)</span>
          </td>
          <td>
            <v-text-field
              v-model="props.items[0].UrineResults.urineStrip.protein.result"
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลตรวจ"
              class="ma-2 textfield-sty"
              color="#00A99D"
            ></v-text-field>
          </td>
          <td style="text-align: center">Negative</td>
        </tr>
        <!-- ---- 1.5 ---- -->
        <tr>
          <td>
            <span>เลือดในปัสสาวะ (Blood)</span>
          </td>
          <td>
            <v-text-field
              v-model="props.items[0].UrineResults.urineStrip.blood.result"
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลตรวจ"
              class="ma-2 textfield-sty"
              color="#00A99D"
            ></v-text-field>
          </td>
          <td style="text-align: center">Negative</td>
        </tr>
        <!-- ---------- -->
        <!-- Urine Microscopy -->
        <tr style="background-color: #f2fcf5">
          <td>
            <span style="color: #00a99d">Urine Microscopy</span>
          </td>
          <td></td>
          <td></td>
        </tr>
        <!-- ---- 1.1 ---- -->
        <tr>
          <td>
            <span>เม็ดเลือดขาว ( WBC/ HPF )</span>
          </td>
          <td>
            <v-text-field
              v-model="props.items[0].UrineResults.urineMicroscopy.wbc.result"
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลตรวจ"
              class="ma-2 textfield-sty"
              color="#00A99D"
              @keypress="validateNumber"
              type="number"
            ></v-text-field>
          </td>
          <td style="text-align: center"> 0-5 /HPF</td>
        </tr>
        <!-- ---- 1.2 ---- -->
        <tr>
          <td>
            <span>เม็ดเลือดแดง ( RBC / HPF )</span>
          </td>
          <td>
            <v-text-field
              v-model="props.items[0].UrineResults.urineMicroscopy.rbc.result"
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลตรวจ"
              class="ma-2 textfield-sty"
              color="#00A99D"
              @keypress="validateNumber"
              type="number"
            ></v-text-field>
          </td>
          <td style="text-align: center">0-5 /HPF</td>
        </tr>
        <!-- ---- 1.3 ---- -->
        <tr>
          <td>
            <span>เซลล์เยื่อบุ (Epithelial cell)</span>
          </td>
          <td>
            <v-text-field
              v-model="
                props.items[0].UrineResults.urineMicroscopy.epithelialCell
                  .result
              "
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลตรวจ"
              class="ma-2 textfield-sty"
              color="#00A99D"
              @keypress="validateNumber"
              type="number"
            ></v-text-field>
          </td>
          <td style="text-align: center">0-5 /HPF</td>
        </tr>
        
        <tr>
          <td>
            <span>แบคทีเรีย (Bacteria)</span>
          </td>
          <td>
            <v-text-field
              v-model="
                props.items[0].UrineResults.urineMicroscopy.bacteria.result
              "
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลตรวจ"
              class="ma-2 textfield-sty"
              color="#00A99D"
            ></v-text-field>
          </td>
          <td style="text-align: center">Few</td>
        </tr>
      </template>
      <!-- <template v-slot:item.listTreatment>
        <td style="text-align: left">แบคทีเรีย (Bacteria)</td>
      </template>
      <template v-slot:item.treatment>
        <td>
          <v-text-field
            v-model="
              item_urinalysis[0].UrineResults.urineMicroscopy.bacteria.result
            "
            flat
            solo
            dense
            hide-details
            placeholder="ระบุผลตรวจ"
            class="ma-2 textfield-sty"
            color="#00A99D"
          ></v-text-field>
        </td>
      </template> -->
      <td style="text-align: center">Negative/Positive</td>
    </v-data-table>
    <!-- ----------------- -->
  </v-container>
</template>

<script>
import { EventBus } from "../../EventBus";
export default {
  data() {
    return {
      headers: [
        {
          text: "รายการตรวจ",
          align: "center",
          sortable: false,
          value: "listTreatment",
        },
        {
          text: "ผลตรวจ",
          align: "center",
          sortable: false,
          value: "treatment",
        },
        {
          text: "ค่าปกติ",
          align: "center",
          sortable: false,
          value: "value",
        },
      ],
      item_urinalysis: [
        {
          UrineResults: {
            urinalysis: {
              //ผลตรวจปัสสาวะ
              colors: "", //สี
              appearance: "", //ความขุ่นใส
            },
            urineStrip: {
              specificGravity: {
                //ความถ่วงจำเพราะ
                result: "", //ผลตรวจ
              },
              ph: {
                //ค่าความเป็นกรด ด่าง
                result: "",
              },
              glucose: {
                //น้ำตาลในปัสสวะ
                result: "",
              },
              protein: {
                //โปรตีนในปัสสาวะ
                result: "",
              },
              blood: {
                //เลือดในปัสสาวะ
                result: "",
              },
            },
            urineMicroscopy: {
              wbc: {
                //เม็ดเลือดขาว
                result: "",
              },
              rbc: {
                //เม็ดเลือดแดง
                result: "",
              },
              epithelialCell: {
                //เซลล์เยื่อบุ
                result: "",
              },
              bacteria: {
                //แบคทีเรีย
                result: "",
              },
            },
          },
        },
      ],
    };
  },
  created() {
    this.detailAll();
  },
  methods: {
    detailAll() {
      EventBus.$on("detailAll_GetOneForm", (item) => {
        if (item !== undefined && item !== null) {
          this.item_urinalysis[0].UrineResults = item.urineResults;
        } else {
          this.item_urinalysis = [
            {
              UrineResults: {
                urinalysis: {
                  //ผลตรวจปัสสาวะ
                  colors: "", //สี
                  appearance: "", //ความขุ่นใส
                },
                urineStrip: {
                  specificGravity: {
                    //ความถ่วงจำเพราะ
                    result: "", //ผลตรวจ
                  },
                  ph: {
                    //ค่าความเป็นกรด ด่าง
                    result: "",
                  },
                  glucose: {
                    //น้ำตาลในปัสสวะ
                    result: "",
                  },
                  protein: {
                    //โปรตีนในปัสสาวะ
                    result: "",
                  },
                  blood: {
                    //เลือดในปัสสาวะ
                    result: "",
                  },
                },
                urineMicroscopy: {
                  wbc: {
                    //เม็ดเลือดขาว
                    result: "",
                  },
                  rbc: {
                    //เม็ดเลือดแดง
                    result: "",
                  },
                  epithelialCell: {
                    //เซลล์เยื่อบุ
                    result: "",
                  },
                  bacteria: {
                    //แบคทีเรีย
                    result: "",
                  },
                },
              },
            },
          ];
        }
      });
    },
    validateNumber: (event) => {
      const keyCode = event.keyCode;
      if (keyCode < 46 || keyCode > 57 || keyCode == 47) {
        event.preventDefault();
      }
    },
  },
  beforeDestroy() {
    EventBus.$off("detailAll_GetOneForm", this.detailPhysicalExam);
  },
};
</script>
<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Sarabun&display=swap");
.my-table thead th {
  background: #00a99d !important;
  color: #ffffff !important;
  &:first-child {
    border-radius: 10px 0 0 0;
  }
  &:last-child {
    border-radius: 0 10px 0 0;
  }
}
.textfield-sty {
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
}
.btn-sty {
  border-radius: 10px;
}
.text-cennter {
  text-align: center;
}

/* สำหรับ Chrome, Edge และเบราว์เซอร์ที่ใช้ WebKit */
::v-deep input[type="number"]::-webkit-inner-spin-button, 
::v-deep input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* สำหรับ Firefox */
::v-deep input[type="number"] {
    -moz-appearance: textfield;
}
</style>
